import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';

import logo from '../assets/images/logo_avenuepm.png';

import Helpers from "../Shared/Helpers";
import {updateAppStates, updateParent, updateStudentAppsStatus, updateStudentUser} from "../StudentsComponent/actions";
import {connect} from "react-redux";
import MyProfileComponent from "../StudentsComponent/MyProfile";
import Footer from "../Shared/Footer";


let addClassInstruction = null;
let addStudentInstruction = null;


class ParentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {students:null, currentStudentNo: 0, currentStudent:null, isRefresh:false};
        this.logout = this.logout.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.showStudent = this.showStudent.bind(this);
    }



    componentDidMount() {
        Helpers.authorize(this);
        REST.getParentStudents().then(async(res)=> {
            await this.setState({students: res.body});
            if (this.state.students) {
                this.showStudent(this.state.currentStudentNo);
            }
        });
    }

    async showStudent (studentNo){
        let studentUser = {student: this.state.students[studentNo]};
        studentUser.student.personalUse = true;
        await this.props.updateStudentUser(studentUser);
        await REST.getStudentAppStatus(studentUser.student.userId).then(async (res) => {
            await this.props.updateStudentAppStatus(res.body);
            let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(studentUser, res.body);
            await this.props.updateAppStates({
                allowedApps: allowedApps,
                filteredApps: filteredApps,
                finishedApps: finishedApps
            });
            this.setState({
                currentStudent: studentUser.student,
                currentApps: res.body,
                isRefresh: true
            });
        });
        return true;
    }

    handleNext = () =>{
        let studentAmount = this.state.students.length;
        this.state.currentStudentNo ++;
        if(this.state.currentStudentNo >= studentAmount){
            this.state.currentStudentNo = 0;
        }
        this.showStudent(this.state.currentStudentNo);
    }

    handleSelect = (selected) => {
        this.props.updateStudentAccountTab(selected);
        this.setState({activeTab: selected});
    };

    logout() {
        this.setState({activeTab: 3});
        REST.logout().then((response) => {
            if (response.success) {
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                this.props.persistor.purge();
                this.props.history.push("/login");
            }
        }, (error) => {
            console.log('Error', error);
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.persistor.purge();
            this.props.history.push("/login");
        });
    }

    render() {
        return (
            <div>
                <nav id="header" className="navbar">
                    <div id="header-container" className="container navbar-container">
                        <div className="navbar-header fl">
                            <a id="brand" className="navbar-brand" href="/">
                                <img src={logo} alt="AvenuePM" border="0"/>
                            </a>
                        </div>
                        <div className="navbar fr">
                            <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul className="nav navbar-nav">
                                    <li><a onClick={this.logout}
                                           className={"handBtn"}><span>Logout</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        { this.state.students && this.state.students.length > 1?
                        <div className="navbar fr">
                            <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul className="nav navbar-nav">
                                    <li><a onClick={this.handleNext}
                                           className={"handBtn"}><span>Next</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>:null}
                        <div className="navbar fr">{this.state.currentStudent?
                            <h3>Parent: {this.state.currentStudent.parent.userId} (Student: {this.state.currentStudent.user.firstname} {this.state.currentStudent.user.lastname})</h3>
                                :null}</div>
                    </div>
                </nav>
                <MyProfileComponent userRole={'parent'} currentStudent={this.state.currentStudent} refresh={this.state.isRefresh} currentApps={this.state.currentApps}/>
                <Footer/>
            </div>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateParent: async(parent) => await dispatch (updateParent(parent)),
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates)),
        updateStudentUser: async (studentUser) => await dispatch(updateStudentUser(studentUser))
    };
};


const mapStateToProps = state => ({
    parent: state.studentReducer.parent,
    apps:state.studentReducer.apps,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(ParentComponent));



// WEBPACK FOOTER //
// ./src/ParentComponent/Parent.js